import type { FormConfig } from '#types/config/components/form'

export default {
  onSuccessNavigateTo: '/sign-in'
} satisfies FormConfig['resetPassword']
